/**
 * All the routes
 */
export const routes = {
	login: "auth/login",
	signup: "auth/signup",
    firebaseLogin: "auth/firebase-login",
	logout: "auth/logout",
	cartItems: "/cart/items",
	cartSync: "/cart/sync",
	customerProducts: "/customers/products",
	deliveryAddress: "/delivery-addresses",
	orders: "/orders",
	companyOrders: (companyId) => `/riders/companies/${companyId}/logistics/orders`,
	viewOrder: (companyId, orderId) => `/companies/${companyId}/orders/${orderId}`,
	markOrderAsReady: (companyId, orderId) => `/companies/${companyId}/orders/${orderId}/ready`,
	markOrderAsProcessing: (companyId, orderId) => `/companies/${companyId}/orders/${orderId}/process`,
	payments: "/payments",
	purchases: "/purchases",
	users: "/users",
	userStats: "/users/stats",
	paymentRequests: "/payment-requests",
	reviews: "/reviews",
	capaPurchases: "/capa-purchases",
	orderPaymentSurpluses: "/order-payment-surpluses",
	settings: "/user-settings",
	awards: "/awards",
	transfers: "/transfers",
	payouts: "/payouts",
	follows: "/follows",
	businesses: "/businesses",
	comments: "/comments",
	mentions: "/mentions",
	deliverers: "/deliverers",
	errands: "/errands",
};